<template>
  <div class="formTitleBox" :title="titleText">
    {{ titleText }}
  </div>
</template>

<script>
export default {
  props: ["titleText"],
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.formTitleBox {
  width: 101%;
  margin-left: -0.5%;
  height: 40px;
  padding-left: 10px;
  box-sizing: border-box;
  color: white;
  line-height: 40px;
  background: var(--themColor);
  box-shadow: 0 10px 10px rgb(168, 168, 168);
  margin-bottom: 15px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/formPageComponents/formTitle.vue